// HM-307: index pagine /dev/* per esplorare il design system v2.6.

import { Link } from 'react-router-dom';

const demos = [
  { href: '/dev/tokens', title: 'Tokens', desc: 'Palette warm completa (HM-301)' },
  { href: '/dev/typography', title: 'Tipografia', desc: 'Inter Variable + scala (HM-302)' },
  { href: '/dev/icons', title: 'Icone', desc: 'Lucide set centralizzato (HM-303)' },
  { href: '/dev/dnd', title: 'Drag & Drop', desc: '@dnd-kit SortableList (HM-304)' },
  { href: '/dev/components', title: 'Componenti', desc: 'shadcn-style palette warm (HM-305)' },
];

export function DevHome() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-2">Design System — pagine demo</h1>
      <p className="text-text-secondary mb-8">
        Riferimento visuale dei building block creati nel cluster 14.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl">
        {demos.map((d) => (
          <Link
            key={d.href}
            to={d.href}
            className="block bg-bg-card border border-border-base rounded-lg p-6 shadow-hm-sm hover:shadow-hm-md transition-shadow"
          >
            <h2 className="text-xl font-semibold text-text-primary">{d.title}</h2>
            <p className="text-sm text-text-secondary mt-1">{d.desc}</p>
            <p className="text-xs text-accent-primary-text mt-3 font-mono">{d.href}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
